<!-- Metas -->
<div class="row">
    <div class="col-12">
        <sgt-representante-configuracao-meta
            [entity]="entity">
        </sgt-representante-configuracao-meta>
    </div>
</div>